import { Component } from "@mna/react";
import { Trans } from "react-i18next";
import i18n from "./../../../i18n";
import i18next from "i18next";
import Modal from "react-modal";
import { backClick } from "./Single";
import {  checkAndGetLocalStorageValue} from "../../../features/utils";
let lang, isQuestionLog;

function interGroupValidation({
	state,
	actions,
	setState,
	nextStepName,
	history,
}) {	
	gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
	var items = document.getElementsByTagName("input");
	const numOfQuestions = [];
	var questionId;
	for (var questOrder = 0; questOrder < items.length; questOrder++) {
		if (
			items[questOrder].type === "radio" &&
			items[questOrder].checked &&
			items[questOrder].value === i18next.t("findcareoption.Yes")
		) {
			questionId = items[questOrder].id.replace(items[questOrder].value,'');
			numOfQuestions.push(questionId);
			console.log(questionId)
		}
		if (
			items[questOrder].type === "radio" &&
			items[questOrder].checked &&
			items[questOrder].value === i18next.t("findcareoption.No")
		) {
			questionId = items[questOrder].id.replace(items[questOrder].value,'');
			numOfQuestions.push(questionId);
			console.log(questionId)
		}
		if (
			items[questOrder].type === "radio" &&
			items[questOrder].checked &&
			items[questOrder].value === i18next.t("findcareoption.DontKnow")
		) {
			questionId = items[questOrder].id.replace(items[questOrder].value,'');
			numOfQuestions.push(questionId);
			console.log(questionId)
		}
	}
	if (numOfQuestions.length !== state.Questions.question.items.length) {
		setState({ showInterviewModal: true });
	} else {
		nextClick({ state, actions, setState, nextStepName, history });
	}
}

async function nextClick({ state, actions, setState, nextStepName, history }) {
	var items = document.getElementsByTagName("input");
	const presentSelected = [];
	const unknownSelected = [];
	const absentSelected = [];
	var questionId;
	for (var questOrder = 0; questOrder < items.length; questOrder++) {
		if (
			items[questOrder].type === "radio" &&
			items[questOrder].checked &&
			items[questOrder].value === i18next.t("findcareoption.Yes")
		) {
			questionId = items[questOrder].id.replace(items[questOrder].value,'');

			var dataId = questionId;

			state.presentQuestionsSelected.push(questionId);
			presentSelected.push(questionId);
console.log(questionId)
			await actions.addPresentQuestionTemp({ dataId });
		}
		if (
			items[questOrder].type === "radio" &&
			items[questOrder].checked &&
			items[questOrder].value === i18next.t("findcareoption.No")
		) {
			questionId = items[questOrder].id.replace(items[questOrder].value,'');
			var dataId = questionId;
			state.absentQuestionsSelected.push(questionId);
			absentSelected.push(questionId);
			console.log(questionId)
			await actions.addAbsentQuestionTemp({ dataId });
		}
		if (
			items[questOrder].type === "radio" &&
			items[questOrder].checked &&
			items[questOrder].value === i18next.t("findcareoption.DontKnow")
		) {
			questionId = items[questOrder].id.replace(items[questOrder].value,'');

			var dataId = questionId;
			state.unknownQuestionsSelected.push(questionId);
			unknownSelected.push(questionId);
			console.log(questionId)
			await actions.addUnknownQuestionTemp({ dataId });
		}
	}
	state.orderIdArray.push(state.Questions.order);

	const data = {
		presentQuestionsSelected: presentSelected,
		absentQuestionsSelected: absentSelected,
		unknownQuestionsSelected: unknownSelected,
	};
	state.questionWithAnswers.push(data);
	await actions.postQuestions(state, actions, setState);
	if (state.Questions.should_stop === true) {
		state.triageRequest.activeMenu = nextStepName;
	}

	state.Questions.should_stop === false
		? actions.getQuestions(
				{ state, actions, setState, nextStepName, history },
				(lang = i18n.language),
				(isQuestionLog = true)
		  )
		: actions.finishQuestionCallback(
				state,
				nextStepName,
				history,
				actions,
				setState,
				state.Questions,
				lang
		  );
}
export default class GroupMultiple extends Component {
	render() {
		const { state, actions, history, setState, nextStepName } = this.props;
		var questionId = [];
		for (
			var questionOrder = 0;
			questionOrder < state.Questions.question.items.length - 1;
			questionOrder++
		) {
			questionId.push(state.Questions.question.items[questionOrder].id);
		}
		return (
			<div className="standby-questions-margin">
				<div className="standby-center">
					<h1 className=" standby-col standby-col-shrink ">
						{state.Questions.question.text}
					</h1>
					<h2 className="fontWeight marginTopQuestion">
						<Trans i18nKey="findcareoption.select_one">
							Select one answer in each row.
						</Trans>
					</h2>
				</div>

				<Modal
					isOpen={state.showInterviewModal}
					contentLabel="customStyles"
					className="ReactModal__Content_triagepopup"
					overlayClassName="ReactModal__Overlay_triagepopup"
					role=""
				>
					<label>
						<label>
							{" "}
							<Trans i18nKey="findcareoption.interviewmodal_message">
								Please Select an answer to continue
							</Trans>{" "}
						</label>
					</label>

					<div className="pop_button">
						<button
							className="modal_no"
							aria-label={i18next.t("findcareoption.interviewmodal_message") + " " + i18next.t("findcareoption.OK")}
							onClick={(e) => {
								setState({
									showInterviewModal: false,
								});
							}}
						>
							<Trans i18nKey="findcareoption.OK">Ok</Trans>
						</button>
					</div>
				</Modal>

				<div>
					{state.Questions.question.items.map(function (item, value) {
						var presentTemp = state.presentQuestionsSelectedTemp.indexOf(
							item.id
						);

						var absentTemp = state.absentQuestionsSelectedTemp.indexOf(item.id);

						var unknownTemp = state.unknownQuestionsSelectedTemp.indexOf(
							item.id
						);

						return (
							<div className=" standby-page-section-rows standby-page-section-rows- standby-page-section-rows-flex standby-page-section-rows-flex-spaced standby-page-section-rows-flex-align-center">
								<div className="standby-split left"> {item.name}</div>

								{item.choices.map((choices) => {
									return (
										<div className=" standby-page-section-rows ">
											<div className="standby-margin radio-button-interview" id={`list_${item.id+choices.label}`}>
												<input
													type="radio"
													name={"group_multiple" + item.id}
													id={item.id+choices.label}
													key={"key_" + item.id}
													className="standby-triagesymptom"
													value={choices.label}
													aria-label={item.name + " " + choices.label}
													defaultChecked={
														choices.label === i18next.t("findcareoption.Yes") &&
														presentTemp > -1
															? presentTemp > -1
															: choices.label ===
																	i18next.t("findcareoption.No") &&
															  absentTemp > -1
															? absentTemp > -1
															: choices.label ===
																	i18next.t("findcareoption.DontKnow") &&
															  unknownTemp > -1
															? unknownTemp > -1
															: null
													}
												/>
												<label for={item.id+choices.label}>{choices.label}</label>
											</div>
										</div>
									);
								})}
								{questionId[value] === item.id ? <hr></hr> : null}
							</div>
						);
					})}
				</div>

				<div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
					<div className="standby-btn-next standby-col standby-col-shrink ">
						{state.presentQuestionsSelected.length > 0 ||
						state.unknownQuestionsSelected.length > 0 ||
						state.absentQuestionsSelected.length > 0 ? (
							<button
								type="button"
								className="button standby-button standby-button-gradient standby-button-gradient-green"
								onClick={() =>
									backClick({ state, actions, setState, nextStepName, history })
								}
							>
								<Trans i18nKey="findcareoption.questions.Back"> Back</Trans>
							</button>
						) : null}
						<button
							type="button"
							className="standby-btn-back button standby-button standby-button-gradient standby-button-gradient-green"
							onClick={() =>
								interGroupValidation({
									state,
									actions,
									setState,
									nextStepName,
									history,
								})
							}
						>
							<Trans i18nKey="findcareoption.questions.Next"> Next</Trans>
						</button>
					</div>
				</div>
			</div>
		);
	}
}
